import { privateRequest } from "../../axios";
import type {
  GetStockRequest,
  Root,
  AddStockPyload,
  AddStockResponse,
} from "./stocks.interface";
const ENDPOINTS = {
  STOCK: "/api/Inventories",
  ADD_STOCK: "/api/Inventory",

  STOCK_ID: (id: Number) => `/api/Inventory/${id}`,
  WAREHOUSE_LIST: "/api/Warehouse/GetAll",
  MOVETOWAREHOUSE : "/api/inventory-transfer"
};

const getStock = async (params: any) => {
  // For POST with query params: pass empty body {} and params in config
  const response = await privateRequest.post<Root>(ENDPOINTS.STOCK, params);
  return response?.data;
};

const addStock = async (data: AddStockPyload) => {
  const response = await privateRequest.post<AddStockResponse>(
    ENDPOINTS.ADD_STOCK,
    data
  );
  return response?.data;
};
const updateStock = async (id: Number, data: AddStockPyload) => {
  const response = await privateRequest.put<AddStockResponse>(
    ENDPOINTS.STOCK_ID(id),
    data
  );
  return response?.data;
};
const deleteStock = async (id: Number) => {
  const response = await privateRequest.delete<AddStockResponse>(
    ENDPOINTS.STOCK_ID(id)
  );
  return response?.data;
};
const getWarehouseList = async (data: any) => {
  const response = await privateRequest.post(ENDPOINTS.WAREHOUSE_LIST, data);
  return response?.data;
};

const  moveStock = async(data :any ) => {
  const response = await privateRequest.post(ENDPOINTS.MOVETOWAREHOUSE, data);
  return response?.data;
}

const StockService = {
  getStock,
  addStock,
  updateStock,
  deleteStock,
  getWarehouseList,
  moveStock
};

export default StockService;
